import { render, staticRenderFns } from "./EquipeModal.vue?vue&type=template&id=28f9b0b8&scoped=true"
import script from "./EquipeModal.vue?vue&type=script&lang=js"
export * from "./EquipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9b0b8",
  null
  
)

export default component.exports